const wcaBaseUrl = process.env.REACT_APP_WCA_SERVER;
export default wcaBaseUrl;
